import { Paper, Box } from '@mui/material';
import SearchBar from '../Shared/SearchBar/SearchBar';
import './Statistics.css';
import { useCallback, useEffect, useState } from 'react';
import StatCard from './StatCard/StatCard';
import {
    getMacroWeights,
    getSampleCounts,
    getPopularItems,
    getPiechartDistribution,
    getUsersCount
} from '../../controllers/StatsController';
import DistributionChart from './DistributionChart/DistributionChart';
import ClassificationTable from './ClassificationTable/ClassificationTable';
import { getExcursionsData } from '../../controllers/ExcursionController';

const FilterOptions = {
    "Years": { type: "range", name: "Années", possibleValues: [2010, new Date().getFullYear()], description: "Sélectionnez une plage d'années pour filtrer les données." },
    "Transect": { type: "range", name: "Longueur transecte", possibleValues: [10, 100], description: "Sélectionnez une plage de longueurs pour filtrer les données." }
};

const FiltersMapping = {
    "Années": "years",
    "Longueur transecte": "transect"
};

const Statistics = () => {
    const [currentFilters, setCurrentFilters] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [excursions, setExcursions] = useState([]);
    const [samplesCount, setSamplesCount] = useState(0);
    const [macroWeights, setMacroWeights] = useState(null);
    const [totalUsers, setTotalUsers] = useState(0);
    const [activeUsers, setActiveUsers] = useState(0);
    const [typesDistribution, setTypesDistribution] = useState(null);
    const [popularItems, setPopularItems] = useState(null);

    useEffect(() => {
        updateStatistics();
        
        getExcursionsData().then((response) => {
            if (response) {
                console.log(response);
                setExcursions(response.map(excursion => {
                    return {
                        id: excursion.id,
                        name: excursion.name,
                    };
                }));
            }
        });
    }, []);

    const updateStatistics = useCallback((queryParams) => {
        getUsersCount(queryParams).then((response) => {
            setTotalUsers(response.total_users);
            setActiveUsers(response.total_active_users);
        });
        getMacroWeights(queryParams).then((response) => {
            setMacroWeights(response);
        });
        getSampleCounts(queryParams).then((response) => {
            setSamplesCount(response.total);
        });
        getPopularItems(queryParams).then((response) => {
            if (response)
                setPopularItems(response);
        });
        getPiechartDistribution(queryParams).then((response) => {
            setTypesDistribution(response);
        });
    }, []);

    useEffect(() => {
        let queryParams = "";
        if (currentFilters.length > 0) {
            queryParams = currentFilters.map(filter => `${FiltersMapping[filter.name]}=${filter.value}`).join("&");
        }
        if (searchValue) {
            const searchId = excursions.find(excursion => excursion.name === searchValue)?.id;
            if (searchId) {
                queryParams += `excursion_id=${searchId}`;
            }
        }
        updateStatistics(queryParams);
    }, [currentFilters, searchValue, excursions, updateStatistics]);

    const isObjectEmpty = (obj) => {
        if (!obj) return true;
        for (const [_, value] of Object.entries(obj)) {
            if (value && Object.keys(value).length !== 0) {
                return false;
            }
        }
        return true;
    };

    const showNoData = () => {
        return !samplesCount && !activeUsers && !(macroWeights && macroWeights.total_macro_weight && macroWeights.average_macro_weight) && isObjectEmpty(popularItems) && isObjectEmpty(typesDistribution);
    }

    const updateFilters = (filters) => {
        setCurrentFilters(filters);
    }

    const updateSearchValue = (value) => {
        setSearchValue(value);
    }

    return (
        <div>
            <h1 className="page-title">Statistiques</h1>
            <SearchBar search={updateSearchValue} applyFilters={updateFilters} searchOptions={excursions.map(excursion => excursion.name)} filterOptions={FilterOptions} autocomplete />
            {!showNoData() ?

                <Paper className="data-container" elevation={3}>
                    <Box display="grid" gridTemplateColumns="repeat(2, 5fr)" margin={1}>
                        {samplesCount && <StatCard key={samplesCount} title={"Nombre de collectes"} value={samplesCount} unit="count" />}
                        {activeUsers && <StatCard title="Utilisateurs" value={`${activeUsers}/${totalUsers}`} unit="utilisateurs actifs" showUnit />}
                        {macroWeights && macroWeights.total_macro_weight && <StatCard title="Poids macro total" value={macroWeights.total_macro_weight} unit="kg" showUnit />}
                        {macroWeights && macroWeights.average_macro_weight && <StatCard title="Poids macro moyen" value={macroWeights.average_macro_weight} unit="kg" showUnit />}
                    </Box>

                    {popularItems && Object.entries(popularItems).map(([key, value]) => {
                        if (value.length === 0) return null;
                        return (
                            <ClassificationTable key={key} name={`Déchets ${key} les plus collectés`} data={value} />
                        );
                    })}
                    {!isObjectEmpty(typesDistribution) && <DistributionChart data={typesDistribution} />}
                </Paper>
                :
                <Paper className="data-container" elevation={3}>
                    <h2>Aucune statistique disponible</h2>
                </Paper>
            }
        </div>
    );
};

export default Statistics;